import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '../lib/query-client';
import App from './App';
import './index.css';

// Initialize i18n (must be imported before App)
import '../lib/i18n';

const isDev = process.env.NODE_ENV === 'development';

// Loading fallback for Suspense (while translations are loading)
const LoadingFallback = () => (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading...</p>
        </div>
    </div>
);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}> {/* React Query Client Provider */}
            <Suspense fallback={<LoadingFallback />}>
                <App />
            </Suspense>
            {isDev && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    </React.StrictMode>
);
